import { DeleteRequest, GetRequest, PostRequest } from "../../plugins/https";
import { addAdmission, deleteAdmission, getAdmission } from "./action";
import { DELETE_ADMISSION, GET_ADMISSION, SET_ADMISSION } from "./actionType";

export const createAdmission =
  (
    personal_details,
    fathers_details,
    mothers_details,
    guardian_details,
    other
  ) =>
  async (dispatch) => {
    const data = {
      personal_details: { ...personal_details },
      fathers_details: { ...fathers_details },
      mothers_details: { ...mothers_details },
      guardian_details: { ...guardian_details },
      other: other,
    };
    try {
      const res = await PostRequest("/admission", data);
      dispatch(addAdmission(res.data));
    } catch (error) {
      console.error("Error adding admission:", error);
    }
  };

export const getAdmissionData = async (dispatch) => {
  try {
    const res = await GetRequest("/admission");
    dispatch(getAdmission(res.data));
  } catch (error) {
    console.error("Error getting contact:", error);
  }
};

export const deleteAdmissionData = (id) => async (dispatch) => {
  try {
    const res = await DeleteRequest(`/admission/${id}`);
    dispatch(deleteAdmission(id));
  } catch (error) {
    console.error("Error in deleting admission: ", error);
  }
};

const initialState = {
  data: [],
  admissionData: [],
};

export const admissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ADMISSION:
      return {
        ...state, // Copy the previous state
        data: [...state.data, action.payload], // Update the 'contact' field with the new contact
      };
    case GET_ADMISSION:
      return {
        ...state, // Copy the previous state
        admissionData: action.payload, // Update the 'contact' field with the new contact
      };
    case DELETE_ADMISSION:
      return {
        ...state,
        admissionData: state.admissionData.filter(
          (item) => item.id !== action.payload
        ),
      };
    default:
      return state;
  }
};
